/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 5c0 2.7614-2.2386 5-5 5S0 7.7614 0 5s2.2386-5 5-5 5 2.2386 5 5ZM8.5 5c0 1.933-1.567 3.5-3.5 3.5S1.5 6.933 1.5 5 3.067 1.5 5 1.5 8.5 3.067 8.5 5ZM24 19c0 2.7614-2.2386 5-5 5s-5-2.2386-5-5 2.2386-5 5-5 5 2.2386 5 5Zm-1.5 0c0 1.933-1.567 3.5-3.5 3.5s-3.5-1.567-3.5-3.5 1.567-3.5 3.5-3.5 3.5 1.567 3.5 3.5Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M12.75 19a.75.75 0 0 0-.75-.75H8c-1.2426 0-2.25-1.0074-2.25-2.25v-2.1893l1.7197 1.7196a.75.75 0 0 0 1.0607-1.0606L5 10.9393l-3.5303 3.5304a.75.75 0 0 0 1.0607 1.0606L4.25 13.8107V16c0 2.0711 1.679 3.75 3.75 3.75h4a.75.75 0 0 0 .75-.75ZM12 5.25a.75.75 0 0 1 0-1.5h4c2.0711 0 3.75 1.679 3.75 3.75v2.6893l1.7197-1.7196a.75.75 0 0 1 1.0606 1.0607L19 13.0606l-3.5303-3.5304a.75.75 0 0 1 1.0606-1.0606l1.7197 1.7196V7.5c0-1.2426-1.0073-2.25-2.25-2.25h-4Z"
    />
  </React.Fragment>,
  'MenuDependencies'
);
